import { Component } from "@angular/core";

@Component({
    selector: "dxp-background",
    templateUrl: "./dxp-background.component.html",
    styleUrls: ["./dxp-background.component.scss"],
    standalone: false
})
export class DxpBackgroundComponent {}
